const ArrowLeft = (props) => {
  return (
    <svg width="24" height="13" viewBox="0 0 24 13" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7.752 0.752044L2.504 6.00004H24V7.00004H2.504L7.752 12.249L7.045 12.956L0.59 6.50004L7.045 0.0450439L7.752 0.752044V0.752044Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ArrowLeft;